export default class EmailValidationApiError extends Error {
  public apiStatus: string;

  constructor(message: string, apiStatus: string) {
    super(message);

    this.apiStatus = apiStatus;
  }
}
